import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button'
import Sides from '../Bars/Cppsidebar';
import { Helmet } from "react-helmet";
function Cscopevar(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
     
      <Sides/>
       <Helmet>
 
<title>Variable Scope tutorial For Beginners</title>
<meta name="description" content="Scope of the variable in a c++ tutorial for beginners.Scope of the variable in a c++ programming language, CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
<meta name="keywords" content="codeexampler,Scope of the variable in a c++ tutorial for beginners,programming language,tutorial for begineers,learn code in free,c++ programming tutorial for beginners,learn code in free online,c++ scope of variable,cpp scope of variables,scope of variable in cpp,scope of variables in cpp pdf,scope of a variable in cpp,what is scope of variable in cpp,cpp programming scope of variables,cpp scope of variable declared in if statement,scope of variable declared in for loop cpp,scope of variables in c++ sharp,scope of variable in c++ language" />
<link rel="canonical" href="https://www.codeexampler.com/cpp-scope-of-variable" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">
    Variable Scope in c++ programming language
</h1>
<div className="first">
        <a href="/cpp-variable"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-element"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Local variable in c++ computer language:</h2>
<p className="mt-3 para">1, These types of variables in the c++ programming language define as inside a function<br/>
2, C++ Can’t use from outside that function.<br/>
3, The initial value will be garbage<br/>
</p>


<h2 className='head3'>Q-Write a program Local variable in c++ example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            
            <span className="qwerty-11">void </span>
            <span className="qwerty-4">show</span>
            <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty"> cout </span>
            <span className="qwerty-10">&#60;&#60;</span>
            <span className="qwerty-10"> i</span>
              <span className="qwerty-3">; </span>
              {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} 
            <span className="qwerty-11"> int </span>
            <span className="qwerty-2">main</span>
              <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-10"> i </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-2"> 10 </span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10"> i </span>
            <span className="qwerty-3">++</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty"> show </span>
            <span className="qwerty-3">( )</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10"> return</span>
              <span className="qwerty-2"> 0</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty">11 </span>
              {"\n"}
              {"\n"}</code></pre>
        </div>
      </div>


<p className="mt-4 para"><span className="bold">Ans-</span>error ! Because undefined symbol i in show() function</p>

<h2 className="mt-4 mh2">Global variable in C++ computer language:
</h2>

<p className="mt-4 para">1, This global variable in a c++ programming language Define  outside all functions and can be used anywhere in the program<br/>
2, The initial value will be zero.<br/>
</p>


<h2 className='head3'>Q-Write a Global program variable in a C++ example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-2">50 </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            
            <span className="qwerty-11">void </span>
            <span className="qwerty-4">show</span>
            <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty"> cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-10"> i </span>
              <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-5">\n</span>
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-10"> i </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-2"> 40</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} 
            <span className="qwerty-11"> int </span>
            <span className="qwerty-2">main</span>
              <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-10"> i </span>
            <span className="qwerty-3">++</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6"> show </span>
            <span className="qwerty-3">( )</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10"> cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-2"> i </span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4"> return</span>
              <span className="qwerty-2"> 0</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty">51 </span>
              {"\n"} 
              <span className="qwerty">40 </span>
              {"\n"}
              {"\n"}</code></pre>
        </div>
      </div>


<h2 className="mt-4 mh2">Static variable in C++ programming language:</h2>
<p className="mt-4 para">1, These types of variables defines inside a function with static keywords.<br/>
2, This can’t rationalize the C++ value of the static variable in the different function calls.<br/>
3, The initial value will be zero<br/>
</p>


<h2 className='head3'>Q-Write a Static program variable in a c++ example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11">void </span>
            <span className="qwerty-4">Show</span>
            <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty"> static </span>
            <span className="qwerty-3">int</span>
            <span className="qwerty-10"> i </span>
              <span className="qwerty-3">= </span>
            <span className="qwerty-5">60</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-10"> cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-2"> i </span>
              <span className="qwerty-3">&#60;&#60; "</span>
              <span className="qwerty-2"> \n</span>
              <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-5"> i </span>
            <span className="qwerty-3">++</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} 
            <span className="qwerty-11"> int </span>
            <span className="qwerty-2">main</span>
              <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-6"> Show </span>
            <span className="qwerty-3">( )</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6"> Show </span>
            <span className="qwerty-3">( )</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6"> Show </span>
            <span className="qwerty-3">( )</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4"> return</span>
              <span className="qwerty-2"> 0</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty">60</span>
              {"\n"} 
              <span className="qwerty">61 </span>
              {"\n"} 
              <span className="qwerty">62 </span>
              {"\n"}
              {"\n"}</code></pre>
        </div>
      </div>


<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/cpp-variable">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-element">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cscopevar;